import { Token } from "./../../../search/helpers/search-tree/token";
import { IDownloadInfo } from "./../../../search/interfaces/download-info";
import { IDocumentModel } from "./../../interfaces/document-model";
import { AppSettings } from "../../../app-settings";
import { AuthorizationModel } from "../../../authentication/models/authorization-model";
import { backboneViewProperties } from "../../../decorators/backbone-properties";
import { AppEvents } from "../../../app-events";
import { autoinject, transient, Container } from "aurelia-dependency-injection";
import { AuthService } from "../../../authentication/auth-service";
import { ContainerHelper } from "../../../shared/helpers/container-helper";

@autoinject
@transient()
export class GenericDownloadView extends Marionette.ItemView<any> {

    public authService: AuthService;
    public template: string;
    private appEvents: Backbone.Events;

    constructor(options?: any) {
        super(options);
        this.appEvents = ContainerHelper.Events;
        this.authService = ContainerHelper.AuthService;
        this.listenTo(this.model, "change:HasPdf", this.onRender);
    }

    public events(): Backbone.EventsHash {
        const events: Backbone.EventsHash = {};
        events["change .js-download-option-box"] = (e) => this.setSubmitButtonStatus();
        events["click .download-submit-button"] = (e) => this.downloadSubmit(this);
        return events;
    }

    public onShow() {
        this.disableForTrialists();
    }

    public disableForTrialists() {
        const $dlButton = this.$(".download-submit-button");
        const $dlLabel = $dlButton.find(".btn-text.show-label");
        const $dlWarning = this.$(".download-warning");
        const $icon = $dlButton.find("i");
        const user  = this.authService.AppUser;

        if (user.IsTrialist) {
            $dlButton.addClass("disallowed"); // use disallowed as disabled will get unset when you click download options
            $dlButton.attr("title", "Download not available to trial users");
            $dlWarning.text("Download not available to trial users").show();
            $dlLabel.text("Download Disabled");
            $icon.attr("class", "fa fa-ban");
        } else if (user.Sku.toLowerCase() === "free" || user.Sku.toLowerCase() === "open") {
            $dlButton.addClass("disallowed"); // use disallowed as disabled will get unset when you click download options
            $dlButton.attr("title", "Download not available to free or open users");
            $dlWarning.text("Download not available for free or open users").show();
            $dlLabel.text("Download Disabled");
            $icon.attr("class", "fa fa-ban");
        } else {
            $dlButton.attr("title", "");
            $dlButton.removeClass("disallowed");
            $dlWarning.text("").hide();
            $dlLabel.text("Download");
            $icon.attr("class", "fa fa-download");
        }
    }

    public onRender() {
        this.setupNonClosingDropDown();
        this.setOptionStatus("pdf");
        this.setSubmitButtonStatus();
    }

    protected setOptionStatus(option: string) {
        const m = this.model;
        const $el = this.$("input[data-download-option=" + option + "]");
        let enableOption = false;
        switch (option) {
            case "pdf":
                enableOption = (m.HasFullText || m.HasPdf) && (m.DocumentAccessSku.toLowerCase() === "pro");
                $el.prop("checked", enableOption);
                break;
            default:
                enableOption = false;
        }
        $el.prop("disabled", !enableOption);
        if (option === "pdf") {
            $el.prop("checked", m.HasPdf); // set default option
        }
    }

    protected downloadSubmit(self: GenericDownloadView) {
        return new Promise((resolve, reject) => {
            if (self.getSelectedCount() === 0) {
                return;
            }

            const qryString = this.getQuerystringParams(self.model.id);
            const downloadUrl = `${AppSettings.DocumentApiUrlPrefix}download/token/${qryString}`;
            this.appEvents.trigger(AppEvents.AppInsightsDocumentDownload, {id: self.model.id, FriendlyUrlTitle: self.model.FriendlyUrlTitle, qryString: qryString, url: downloadUrl, RenderType: self.model.RenderType});

            const info: IDownloadInfo = {
                TokenId: self.model.id,
                QueryStringParams: qryString
            };
            this.download(info);
         });
    }

    protected download(downloadInfo: IDownloadInfo) {
        return new Promise((resolve, reject) => {
            const user  = this.authService.AppUser;
            if (user.IsTrialist) {
                reject();
                return;
            }

            const url = `${AppSettings.DocumentApiUrlPrefix}downloadtoken/${downloadInfo.TokenId}`;

            $.ajax(url, {
                beforeSend: AuthorizationModel.attachAuthorizationHeader,
                cache: false
            }).done((response) => {
                const tokenUrl = `${AppSettings.DocumentApiUrlPrefix}download/${response.Token}/${downloadInfo.QueryStringParams}&GVAccId=${response.GVAccId}&GVConId=${response.GVConId}`;
                window.location.href = tokenUrl;

                if (downloadInfo.Callback) {
                    downloadInfo.Callback();
                }
                resolve();
            }).fail(() => {
                this.appEvents.trigger(AppEvents.ErrorMessage, "Could not download file");
                reject();
            });
        });
    }

    protected setSubmitButtonStatus() {
        const $el = this.$(".download-submit-button");
        (this.getSelectedCount() === 0) ? $el.addClass("disabled") : $el.removeClass("disabled");
    }

    protected setupNonClosingDropDown() {
        this.$("ul").on("keydown", (e: JQueryEventObject) => {
            if (e.keyCode === 27) {
                this.$el.removeClass("open");
            }
        }).find("label").on("click", (e: JQueryEventObject) => {
            e.stopPropagation();
        });
    }

    protected getQuerystringParams(docKey: string) {
        const selectedOptions: string[] = [];
        this.$(".js-download-option-box:checked").each(function() { // Don't make this an arrow function, we need "this"
            selectedOptions.push($(this).attr("data-download-option"));
        });
        let qryString = "";
        let separator = "?";
        $.each(selectedOptions, (index, value) => {
            separator = (index === 0) ? "?" : "&";
            qryString += separator + value.replace("-", "") + "=true";
        });
        separator = (qryString === "") ? "?" : "&";
        qryString += separator + "docKey=" + docKey;

        return qryString;
    }

    protected getSelectedCount(): number {
        const n: number = this.$(".js-download-option-box:checked").length;
        return n;
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/views/partials/generic-download.ts